/* eslint-disable @typescript-eslint/no-explicit-any --- while not nice, no other realy options is possible */
export const deepEqual = (obj1: any, obj2: any): boolean => {
  const isEqual = (val1: any, val2: any): boolean => {
    if (val1 === val2) return true;
    if (typeof val1 !== typeof val2) return false;
    if (typeof val1 !== 'object' || val1 === null || val2 === null)
      return false;

    const arraysEqual = (arr1: any[], arr2: any[]): boolean => {
      if (arr1.length !== arr2.length) return false;
      for (let i = 0; i < arr1.length; i++) {
        if (!isEqual(arr1[`${i}`], arr2[`${i}`])) return false;
      }
      return true;
    };

    if (Array.isArray(val1)) {
      return arraysEqual(val1, val2);
    }

    const keys1 = Object.keys(val1);
    const keys2 = Object.keys(val2);
    if (keys1.length !== keys2.length) return false;

    for (const key of keys1) {
      if (!isEqual(val1[`${key}`], val2[`${key}`])) return false;
    }

    return true;
  };

  return isEqual(obj1, obj2);
};
